<template>
  <div ref="listWrap">
    <wrapper-list
      @add="paasAddPage"
      @edit="paasEidtPage"
      @delete="paasDeleteTableData"
      @detail="paasDetailPage"
      @calculate="paasCalculate"
      ref="listWrap">
      <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
        <Row>
          <FormItem label="用户名:" class="ivu-col-span-12">
            <Input  v-model="queryParam.query_LIKE_name"  @on-change="queryTableDatas" clearable style="width: auto" />
          </FormItem>
          <FormItem label="账号:" class="ivu-col-span-12">
            <Input  v-model="queryParam.query_LIKE_accountLogin"  @on-change="queryTableDatas" clearable style="width: auto" />
          </FormItem>
        </Row>
      </Form>
      <Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
      </Table>
      <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
      </Page>
    </wrapper-list>
    <Modal v-model="roleSelectModal" class="paas-select-page" width="60" title="角色选择">
      <RoleSelect ref="selectRole" :datas="userSelectedRoles" @save="saveUserRole"/>
      <div slot="footer">
      </div>
    </Modal>
  </div>
</template>

<script>
  import wrapperList from "@components/paas/wrapper-list.vue";
  import metaList from "@assets/js/list/meta-list.js";
  import CellBar from '@components/paas/cell-bar' //列表内操作
  import RoleSelect from '@views/sys/role/select';
  import { getUserRole , saveUserRole} from "@api/admin.js";
  export default {
    name: "list",
    components:{wrapperList,CellBar,RoleSelect},
    mixins: [ metaList],
    data(){
      return{
        serviceUrl:"/sys/user",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        queryParam:{
          query_LIKE_name:'',
          query_LIKE_accountLogin:'',
          queryOrderBy_:"createTime@DESC"
        },
        //keepAliveName:"sysBugEdit",  //从这些路由到当前list路由需要缓存list的配置
        defaultLabelWidth:120,
        tableHeight:0,
        tableData:[],  //表单数据
        tableColumns:[
          {
            type:'selection',
            key:'id',
            width:36,
            align:'center'
          },
          {
            title: '用户名',
            key: 'name',
            align:'center',
          },
          {
            title: '账号',
            key: 'accountLogin',
            sortable: true,
            align:'center',
          },
          {
            title:'操作',
            align:'center',
            width:200,
            render:(h,params)=>{
              return h(CellBar,{
                props:{
                  show:"icon",
                },
                on: {
                  'edit': ()=> {
                    this.$nextTick(()=>{
                      this.paasEditOper(params.row[this.currentIdFiledName]);
                    })
                  },
                  'delete':()=>{
                    this.$nextTick(()=>{
                      this.paasDeleteOper(params.row[this.currentIdFiledName]);
                    })
                  },
                  'detail':()=>{
                    this.$nextTick(()=>{
                      this.paasDetailOper(params.row[this.currentIdFiledName]);
                    })
                  },
                  'assignRole':()=>{
                    this.$nextTick(()=>{
                      this.tableSelectedDatas = [params.row];
                      this.userRoleSelect();
                    })
                  }
                }
              })
            }
          },
        ],
        roleSelectModal: false,
        userSelectedRoles: [],
      }
    },
    methods:{
      userRoleSelect() {
        if(this.tableSelectedDatas.length !== 1) {
          this.$Modal.warning({
            title: "系统提示",
            content: "请选择一个用户数据!"
          });
          return ;
        }
        getUserRole(this.tableSelectedDatas[0].id).then(
          res=>{
            if(res.code === 200) {
              this.userSelectedRoles = res.data.roles;
              this.roleSelectModal = true;
              this.$refs.selectRole.paasInitSelectedTable();
            }
          }).catch(res=>{
          this.$Message.error("操作失败，请重试！");
        });
      },

      saveUserRole(roles) {
        let sysRoleIds = "";
        for(let i = 0; i < roles.length; i++) {
          if(sysRoleIds) {
            sysRoleIds += ",";
          }
          sysRoleIds += roles[i].id;
        }
        let param = {};
        param.sysUserId = this.tableSelectedDatas[0].id;
        param.sysRoleIds = sysRoleIds;
        saveUserRole(param).then(
          res=> {
            if(res.code === 200) {
              this.roleSelectModal = false;
              this.$Message.info("用户权限保存成功！");
            }
          }).catch(error=> {
            this.$Message.error("操作失败，请重试！");
        });
      },
    }
  }
</script>

<style scoped>

</style>
